module.exports = __webpack_public_path__ + "static/media/flashlight.f384dc67.svg";